import { FuseNavigation } from '@fuse/types';

export const navigation: FuseNavigation[] = [
    {
        id       : 'applications',
        title    : 'Opciones',
        translate: 'Opciones',
        type     : 'group',
        icon     : 'apps',
        children : [
            {
                id: 'dashboards',
                title: 'Dashboard',
                translate: 'Dashboard',
                type: 'item',
                icon: 'dashboard',
                url: '/apps/dashboards/analytics'
            },
            {
                id: 'citas',
                title: 'Citas Programadas',
                translate: 'Citas Programadas',
                type: 'item',
                icon: 'folder_open',
                url: '/apps/e-commerce/type/prog'
            },
            {
                id: 'products',
                title: 'Resultados',
                translate: 'Resultados',
                type: 'item',
                icon: 'assignment',
                url: '/apps/e-commerce/products'
            },
            {
                id: 'documents',
                title: 'Documentación ',
                translate: 'Documentación ',
                type: 'item',
                icon: 'assignment',
                url: '/apps/e-commerce/documents'
            },
            {
                id: 'logout',
                title: 'Salir',
                translate: 'Salir',
                type: 'item',
                icon: 'exit_to_app',
                url: 'pages/auth/login-2'
            }
        ]
    }
];
